import Vue from 'vue'
import Vuex from 'vuex'
import Presistent from './plugins'
import getters from './getters'
Vue.use(Vuex)

const modulesFiles = require.context('./modules', true, /\.js$/)

// you do not need `import app from './modules/app'`
// it will auto require all vuex module from modules file
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
  // set './app.js' => 'app'
  const moduleName = modulePath.replace(/^\.\/(.*)\.\w+$/, '$1')
  const value = modulesFiles(modulePath)
  modules[moduleName] = value.default
  return modules
}, {})

const presistent = Presistent({
  key: 'student',
  modules,
  modulesKeys: {
    session: Object.keys(modules),
    local: []
  }
})

const store = new Vuex.Store({
  modules,
  getters,
  plugins: [presistent]
})

export default store
